import { render, staticRenderFns } from "./ImageWithButtonsBlock.vue?vue&type=template&id=16eae906&scoped=true"
import script from "./ImageWithButtonsBlock.vue?vue&type=script&lang=js"
export * from "./ImageWithButtonsBlock.vue?vue&type=script&lang=js"
import style0 from "./ImageWithButtonsBlock.vue?vue&type=style&index=0&id=16eae906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16eae906",
  null
  
)

export default component.exports